@if (isAdmin()) {
  <div class="sidebar-container">
    <div class="sidebar-module-container">
      <p-drawer
        [(visible)]="sidebarVisible"
        [modal]="false"
        class="menu-sidebar"
        styleClass="sidebar"
        [closable]="true"
        closeIcon="pi pi-arrow-left"
      >
        <div class="pd-navigation">
          <!-- <h5
          class="pd-navigation-tab-headers start"
          [class.pd-navigation-tab-headers-selected]="activeTabSignal() === ProjectPage.Start"
          (click)="routeToStart()"
        >
          Start
        </h5> -->
          <h5
            class="pd-navigation-tab-headers start"
            [class.pd-navigation-tab-headers-selected]="activeTab() === ProjectPage.Repository"
            (click)="routeToRepository()"
          >
            Ablage
          </h5>
          <h5
            class="pd-navigation-tab-headers"
            [class.pd-navigation-tab-headers-selected]="activeTab() === ProjectPage.Chatbot"
            (click)="routeToChatbot()"
          >
            Chatbot
          </h5>
          <h5
            class="pd-navigation-tab-headers end"
            [class.pd-navigation-tab-headers-selected]="activeTab() === ProjectPage.Management"
            (click)="routeToProjectManagement()"
          >
            Projektverwaltung
          </h5>
        </div>
      </p-drawer>
      <button
        pButton
        type="button"
        class="sidebar-menu-button secondary-button"
        [class.sidebar-menu-button-highlighted]="sidebarVisible"
        (click)="sidebarVisible = !sidebarVisible"
      >
        <span class="pi pi-align-justify"></span>
      </button>
    </div>
  </div>
}
